import $ from 'jquery'
import '@selectize/selectize'
import { scroll } from './_smooth-scroll'

export default function CarArchive () {
  const ARCHIVES = document.querySelectorAll('.mtt-cars-archive')
  if (ARCHIVES.length > 0) {
    for (let i = 0; i < ARCHIVES.length; i++) {
      const ARCHIVE = new CarArchiveClass(ARCHIVES[i])
      ARCHIVE.init()
    }
  }
}

class CarArchiveClass {
  constructor (CONTAINER) {
    this.CONTAINER = CONTAINER
    this.TARGET = this.CONTAINER.querySelector('.mtt-cars-archive__content-container')
    this.PAGINATION_TARGET = this.CONTAINER.querySelector('.mtt-cars-archive__pagination')
    this.BREADCRUMBS_TARGET = this.CONTAINER.querySelector('.mtt-cars-archive__results')
    this.LOADER = this.CONTAINER.querySelector('.mtt-cars-archive__loader')

    this.data = {
      action: 'filter_cars_archive',
      url: this.CONTAINER.dataset.url,
      sort: this.CONTAINER.dataset.sort,
      sort_direction: this.CONTAINER.dataset.sortDirection,
      page_number: this.CONTAINER.dataset.pageNumber !== '' ? this.CONTAINER.dataset.pageNumber : 1,
      dealer: this.CONTAINER.dataset.dealer !== '' ? this.CONTAINER.dataset.dealer : 0,
      payment: this.CONTAINER.dataset.payment !== '' ? this.CONTAINER.dataset.payment : 0,
      type: this.CONTAINER.dataset.type !== '' ? this.CONTAINER.dataset.type : 0,
      make: this.CONTAINER.dataset.make !== '' ? this.CONTAINER.dataset.make : 0,
      model: this.CONTAINER.dataset.model !== '' ? this.CONTAINER.dataset.model : 0,
      leasing_price: this.CONTAINER.dataset.leasingPrice !== '' ? this.CONTAINER.dataset.leasingPrice : 0, // Set default
      financing_price: this.CONTAINER.dataset.financingPrice !== '' ? this.CONTAINER.dataset.financingPrice : 0, // Set default
      fuel: this.CONTAINER.dataset.fuel !== '' ? this.CONTAINER.dataset.fuel : 0 // Set default
    }

    this.url_parameters = this.getUrlParameters()
  }

  init () {
    this.initSelectize()
    this.initPagination()
    this.toggleCarsArchiveFilters()
  }

  /**
   * Init selectize instances
   */
  initSelectize () {
    // Init payment select
    const PAYMENT_SELECT = $('.mtt-cars-archive__filter-select[name="payment"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.payment = val === '' ? 0 : val
        this.filterCarsArchive('payment')
      },
      create: false
    })
    this.PAYMENT_SELECT = PAYMENT_SELECT.length > 0 ? PAYMENT_SELECT[0].selectize : null
    if ('payment' in this.url_parameters && this.PAYMENT_SELECT) {
      this.PAYMENT_SELECT.setValue(this.url_parameters.payment, true)
    }
    this.PAYMENT_SELECT && this.PAYMENT_SELECT.on('focus', () => {
      if (this.data.payment === 0) this.PAYMENT_SELECT.clear(true)
    })

    // Init type select
    const TYPE_SELECT = $('.mtt-cars-archive__filter-select[name="type"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.type = val === '' ? 0 : parseInt(val)
        this.filterCarsArchive('type')
      },
      create: false
    })
    this.TYPE_SELECT = TYPE_SELECT.length > 0 ? TYPE_SELECT[0].selectize : null
    if ('type' in this.url_parameters && this.TYPE_SELECT) {
      this.TYPE_SELECT.setValue(this.url_parameters.type, true)
    }
    this.TYPE_SELECT && this.TYPE_SELECT.on('focus', () => {
      if (this.data.type === 0) this.TYPE_SELECT.clear(true)
    })

    const DEALER_SELECT = $('.mtt-cars-archive__filter-select[name="dealer"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.dealer = val === '' ? 0 : parseInt(val)
        this.filterCarsArchive('dealer')
      },
      create: false
    })
    this.DEALER_SELECT = DEALER_SELECT.length > 0 ? DEALER_SELECT[0].selectize : null
    if ('dealer' in this.url_parameters && this.DEALER_SELECT) {
      this.DEALER_SELECT.setValue(this.url_parameters.dealer, true)
    }
    this.DEALER_SELECT && this.DEALER_SELECT.on('focus', () => {
      if (this.data.dealer === 0) this.DEALER_SELECT.clear(true)
    })

    // Init model select
    const MODEL_SELECT = $('.mtt-cars-archive__filter-select[name="model"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.model = val === '' ? 0 : parseInt(val)
        this.filterCarsArchive('model')
      },
      create: false
    })
    this.MODEL_SELECT = MODEL_SELECT.length > 0 ? MODEL_SELECT[0].selectize : null
    if ('model' in this.url_parameters && this.MODEL_SELECT) {
      this.MODEL_SELECT.setValue(this.url_parameters.model, true)
    }
    this.MODEL_SELECT && this.MODEL_SELECT.on('focus', () => {
      if (this.data.model === 0) this.MODEL_SELECT.clear(true)
    })

    // Init leasing select
    const LEASING_SELECT = $('.mtt-cars-archive__filter-select[name="leasing"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.leasing_price = val === '' ? '0' : val
        this.filterCarsArchive('leasing')
      },
      create: false
    })
    this.LEASING_SELECT = LEASING_SELECT.length > 0 ? LEASING_SELECT[0].selectize : null
    if ('leasing_price' in this.url_parameters && this.LEASING_SELECT) {
      this.LEASING_SELECT.setValue(this.url_parameters.leasing_price, true)
    }
    this.LEASING_SELECT && this.LEASING_SELECT.on('focus', () => {
      if (this.data.leasing_price == 0) this.LEASING_SELECT.clear(true)
    })

    // Init financing_price select
    const FINANCING_PRICE_SELECT = $('.mtt-cars-archive__filter-select[name="financing_price"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.financing_price = val === '' ? '0' : val
        this.filterCarsArchive('financing_price')
      },
      create: false
    })
    this.FINANCING_PRICE_SELECT = FINANCING_PRICE_SELECT.length > 0 ? FINANCING_PRICE_SELECT[0].selectize : null
    if ('financing_price' in this.url_parameters && this.FINANCING_PRICE_SELECT) {
      this.FINANCING_PRICE_SELECT.setValue(this.url_parameters.financing_price, true)
    }
    this.FINANCING_PRICE_SELECT && this.FINANCING_PRICE_SELECT.on('focus', () => {
      if (this.data.financing_price == 0) this.FINANCING_PRICE_SELECT.clear(true)
    })

    // Init fuel select
    const FUEL_SELECT = $('.mtt-cars-archive__filter-select[name="fuel"]').selectize({
      onChange: (val) => {
        this.data.page_number = 1 // reset page_number
        this.data.fuel = val === '' ? '0' : val
        this.filterCarsArchive()
      },
      create: false
    })
    this.FUEL_SELECT = FUEL_SELECT.length > 0 ? FUEL_SELECT[0].selectize : null
    if ('fuel' in this.url_parameters && this.FUEL_SELECT) {
      this.FUEL_SELECT.setValue(this.url_parameters.fuel, true)
    }
    this.FUEL_SELECT && this.FUEL_SELECT.on('focus', () => {
      if (this.data.fuel == 0) this.FUEL_SELECT.clear(true)
    })

    // Init make selectize
    const MAKE_SELECT = $('.mtt-cars-archive__filter-select[name="make"]').selectize({
      onChange: (val) => {
        this.data.model = 0 // reset model
        this.data.page_number = 1 // reset page_number
        this.data.make = val === '' ? 0 : parseInt(val)
        this.filterModels()
        this.filterCarsArchive('make')
      },
      create: false
    })
    this.MAKE_SELECT = MAKE_SELECT.length > 0 ? MAKE_SELECT[0].selectize : null
    if ('make' in this.url_parameters && this.MAKE_SELECT) {
      this.MAKE_SELECT.setValue(this.url_parameters.make, true)
    }
    this.MAKE_SELECT && this.MAKE_SELECT.on('focus', () => {
      if (this.data.make === 0) this.MAKE_SELECT.clear(true)
    })
  }

  filterCarsArchive (where = '') {
    this.showLoader()
    $.post(main_theme_objects.ajax_url, this.data, (response) => {
      if (response !== 0) {
        if (this.TARGET) this.TARGET.innerHTML = response.markup
        if (this.PAGINATION_TARGET) this.PAGINATION_TARGET.innerHTML = response.pagination
        if (this.BREADCRUMBS_TARGET) this.BREADCRUMBS_TARGET.innerHTML = response.breadcrumbs
        this.hideLoader()
        this.setBrowserHistory()
      }
    })
  }

  /**
   * Update models when selecting make
   */
  filterModels () {
    const DATA = {
      action: 'filter_models',
      make: this.data.make
    }

    $.post(main_theme_objects.ajax_url, DATA, (response) => {
      if (response !== 0) {
        // clear current options
        this.MODEL_SELECT.clear(true)
        this.MODEL_SELECT.clearOptions(true)

        const MODELS = response.models ? JSON.parse(response.models) : []

        if (MODELS.length > 0) {
          for (let i = 0; i < MODELS.length; i++) {
            const MODEL = MODELS[i]
            this.MODEL_SELECT.addOption({ value: MODEL.key, text: MODEL.value })
          }
          this.MODEL_SELECT.refreshOptions(false)
          this.MODEL_SELECT.setValue(0, true)
        }
      }
    })
  }

  showLoader () {
    if (this.LOADER) this.LOADER.classList.add('loader--show')
  }

  hideLoader () {
    if (this.LOADER) this.LOADER.classList.remove('loader--show')
  }

  initPagination () {
    const that = this
    $(document).on('click', '.mtt-pagination__toggle', function (e) {
      e.preventDefault()
      that.data.page_number = $(this).data('page')
      that.filterCarsArchive()
      scroll(that.BREADCRUMBS_TARGET)
    })
  }

  setBrowserHistory () {
    let parametersString = this.data.url
    const parameters = []

    // add pagenumber
    if ('page_number' in this.data && parseInt(this.data.page_number) > 1) {
      parameters.push(`page_number=${this.data.page_number}`)
    }

    // add dealer
    if ('dealer' in this.data && parseInt(this.data.dealer) !== 0) {
      parameters.push(`dealer=${this.data.dealer}`)
    }

    // add payment
    if ('payment' in this.data && parseInt(this.data.payment) !== 0) {
      parameters.push(`payment=${this.data.payment}`)
    }

    // add type
    if ('type' in this.data && parseInt(this.data.type) !== 0) {
      parameters.push(`type=${this.data.type}`)
    }

    // add make
    if ('make' in this.data && parseInt(this.data.make) !== 0) {
      parameters.push(`make=${this.data.make}`)
    }

    // add model
    if ('model' in this.data && parseInt(this.data.model) !== 0) {
      parameters.push(`model=${this.data.model}`)
    }

    // add leasing_price
    if ('leasing_price' in this.data && parseInt(this.data.leasing_price) !== 0) {
      parameters.push(`leasing_price=${this.data.leasing_price}`)
    }

    // add financing_price
    if ('financing_price' in this.data && parseInt(this.data.financing_price) !== 0) {
      parameters.push(`financing_price=${this.data.financing_price}`)
    }

    // add fuel
    if ('fuel' in this.data && parseInt(this.data.fuel) !== 0) {
      parameters.push(`fuel=${this.data.fuel}`)
    }

    if (parameters.length > 0) {
      for (let i = 0; i < parameters.length; i++) {
        parametersString += i === 0 ? '?' : '&'
        parametersString += parameters[i]
      }
    }

    window.history.pushState('car_archive', '', parametersString)
  }

  getUrlParameters () {
    const queryArray = window.location.search.substr(1).split('&')
    const parameters = {}
    if (queryArray.length > 0) {
      for (let i = 0; i < queryArray.length; i++) {
        const queryItem = queryArray[i]
        const chunks = queryItem.split('=')
        parameters[chunks[0]] = chunks[1]
      }
    }
    return parameters
  }

  toggleCarsArchiveFilters () {
    const acc = this.CONTAINER.querySelector('.mtt-cars-archive__title-container')
    acc && acc.addEventListener('click', function () {
      if ($(window).width() < 1160) {
        const panel = this.nextElementSibling
        $(panel).slideToggle()
        this.classList.add('accordion__isClicked')
        setTimeout(() => { this.classList.remove('accordion__isClicked') }, 400)
      }
    })
  }
}
